module.exports = __webpack_public_path__ + "img/million.9b609ab4.svg";